<template>
  <v-app-bar
    height="80"
    app
    color="white"
    elevate-on-scroll
    flat
    class="modern-header"
  >
    <!-- Left: Logo -->
    <v-toolbar-title
      style="padding-left: 50px"
      class="logo"
      @click="goHome"
    >
      <v-img
        src="@/assets/icons/OhYesMainLogo.png"
        alt="OH.YES Logo"
        contain
        height="52"
        width="140"
      />
    </v-toolbar-title>

    <v-spacer />

    <!-- Desktop Nav -->
    <div class="hidden-sm-and-down nav-links">
      <router-link
        v-for="item in menuItems"
        :key="item.title"
        :to="item.path"
        class="nav-link"
        exact
        :class="{ active: $route.path === item.path }"
      >
        {{ item.title }}
      </router-link>
    </div>

    <!-- Mobile Menu Icon -->
    <v-app-bar-nav-icon
      class="hidden-md-and-up"
      color="#000"
      @click.stop="drawer = true"
    />

    <!-- Mobile Drawer -->
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      right
      color="#fff"
      overlay
    >
      <div class="pa-4 d-flex align-center justify-space-between">
        <div class="text-h6" style="font-weight: 700; color: #000">Menu</div>
        <v-btn icon @click="drawer = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-divider></v-divider>

      <v-list dense>
        <router-link
          v-for="item in menuItems"
          :key="item.title"
          :to="item.path"
          exact
          class="drawer-link"
          @click.native="closeDrawerOnNav"
        >
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title
                style="color: #000; font-weight: 600"
              >
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
      </v-list>

      <v-divider class="my-4"></v-divider>

      <div class="px-4">
        <router-link
          style="text-decoration: none"
          :to="`${basePath}/contact`"
          @click.native="closeDrawerOnNav"
        >
          <v-btn block color="#ff6b35" dark rounded elevation="2">
            Register as Partner
          </v-btn>
        </router-link>
      </div>
    </v-navigation-drawer>
  </v-app-bar>
</template>

<script>
export default {
  name: "HeaderPage",

  data() {
    return {
      drawer: false,
    };
  },

  computed: {
    // Detect US user
    isUS() {
      return (
        this.$route.meta?.location === "us" ||
        localStorage.getItem("isUS") === "true"
      );
    },

    // Base path depending on country
    basePath() {
      return this.isUS ? "/us" : "";
    },

    // Navigation menu
    menuItems() {
      return [
        { title: "Home", path: `${this.basePath}/` },
        { title: "About", path: `${this.basePath}/about` },
        { title: "Services", path: `${this.basePath}/services` },
        { title: "Blog", path: `${this.basePath}/blog` },
        { title: "News", path: `${this.basePath}/news` },
      ];
    },
  },

  watch: {
    // Close drawer on route change (mobile safety)
    $route() {
      this.drawer = false;
    },
  },

  methods: {
    closeDrawerOnNav() {
      this.$nextTick(() => {
        this.drawer = false;
      });
    },

    // Logo click handler (IMPORTANT)
    goHome() {
      this.$router.push(this.basePath || "/");
    },
  },
};
</script>

<style scoped>
.modern-header {
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.logo {
  cursor: pointer;
}

.nav-links {
  display: flex;
  gap: 40px;
  align-items: center;
}

.nav-link {
  font-size: 15px;
  color: #000;
  text-decoration: none;
  font-weight: 700;
  position: relative;
  transition: opacity 0.25s ease;
}

.nav-link:hover {
  opacity: 0.7;
}

.nav-link.active {
  font-weight: 700;
}

.nav-link.active::after {
  content: "";
  position: absolute;
  bottom: -6px;
  left: 0;
  right: 0;
  height: 2px;
  background: #ff6b35;
}

.drawer-link {
  text-decoration: none;
  display: block;
}
</style>
